import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, shareReplay } from 'rxjs';
import { DynamicScript, LoadScripts } from 'src/app/shared/utilities/load-scripts.function';
import { LoggingService } from '@fgb/core';

@Injectable({ providedIn: 'root' })
export class StreamAMGService {
  private loadScript$?: Observable<void>;
  private readonly URL = 'https://sdk.playback.streamamg.com/v1/playback.js';

  constructor(private loggingService: LoggingService) {}

  loadJs() {
    if (this.loadScript$) {
      return this.loadScript$;
    }

    this.loadScript$ = from(LoadScripts([{ src: this.URL }] as DynamicScript[])).pipe(
      map(() => void 0),
      catchError((error) => {
        this.loggingService.error('Failed to load Stream AMG', error);
        throw error;
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    return this.loadScript$;
  }
}
